import { createApp } from 'vue'
import { createPinia } from 'pinia';
import App from './App.vue'
import i18n from './plugins/i18n/i18n'

createApp(App).use(i18n).use(createPinia()).mount('#tx-product-model_list')
